<se-fe-page>
  <se-fe-header
    seFePageHeader
    seFeDataTitle="Edit Profile Modal"
    seFeDataSubtitle="Display modal to edit and save profile changes"
    size="750">
  </se-fe-header>

  <div seFePageContent>
    <se-fe-card>
      <se-fe-card-header
        seFeDataTitle="When to use"
      ></se-fe-card-header>
      <se-fe-card-content>
        <p>Use in MySe Households or in other places where we edit profiles</p>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card>
      <se-fe-card-header seFeDataTitle="Self Persona Example Code"></se-fe-card-header>
      <se-fe-card-content>
        <se-po-edit-persona-modal-self-example></se-po-edit-persona-modal-self-example>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card>
      <se-fe-card-header seFeDataTitle="Self Persona with Contact Info Example Code"></se-fe-card-header>
      <se-fe-card-content>
        <se-po-edit-persona-modal-self-contact-info-example></se-po-edit-persona-modal-self-contact-info-example>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card>
      <se-fe-card-header seFeDataTitle="Child Profile Example Code"></se-fe-card-header>
      <se-fe-card-content>
        <se-po-edit-persona-modal-child-example></se-po-edit-persona-modal-child-example>
      </se-fe-card-content>
    </se-fe-card>
  </div>
</se-fe-page>
